import MainImage from '../voluntary-template/icons/VoluntaryCargo.png';
import VectorFirst from '../voluntary-template/icons/box/shield.svg';
import VectirSecond from '../voluntary-template/icons/box/clinical_notes.svg';
import VectorThird from '../voluntary-template/icons/box/portfolio.svg';
import Checkbox from '../voluntary-template/icons/Checkbox.svg';
import Thunder from '../voluntary-template/icons/Thunder.svg';
import Contract from '../voluntary-template/icons/VoluntaryCargoGPO.png';
import Shield from '../voluntary-template/icons/Shield.png';
import Star from '../voluntary-template/icons/Star.png';
import Pyramid from '../voluntary-template/icons/pyramid.png';
import People from '../voluntary-template/icons/people.png';
import Box from '../voluntary-template/icons/Box.png';

const voluntaryCargoResources = {
  en: {
    voluntaryCargo: {
      title: 'Cargo Insurance',
      description:
        'Ensure the safety of your cargo throughout the entire route — from dispatch to delivery. These solutions are suitable for companies of all sizes, from small businesses to large logistics operators.',
      buttonText: 'Submit application',
      infoCards: [
        {
          title: 'Comprehensive Coverage',
          content:
            'Protection against the risk of loss, damage, or theft of cargo at all stages of transportation.',
        },
        {
          title: 'All Types of Cargo',
          content:
            'We insure general, containerized, hazardous, and other types of cargo.',
        },
        {
          title: 'Global Protection',
          content:
            'Applies both within Kazakhstan and internationally — covering the entire route.',
        },
      ],
      coverage: [
        {
          title: 'What we Insure',
          content: [
            'General, containerized, and bulk cargo',
            'Hazardous goods and items with special transportation conditions',
          ],
        },
        {
          title: 'Covered Risks',
          content: [
            'Losses from total or partial destruction or damage of cargo',
            'Losses due to general average',
            'Expenses incurred to save cargo and minimize damage',
          ],
        },
        {
          title: 'Illustration',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Insurance Amount',
          content:
            'Determined individually based on the cargo value and transportation route.',
        },
        {
          title: 'Coverage Period',
          content:
            'For the entire transportation period — from the point of departure to the point of delivery.',
        },
        {
          title: 'Coverage Area',
          content:
            'Republic of Kazakhstan and international routes, including multimodal transportation.',
        },
      ],
      formTitle: 'Insurance Application',
      formDescription:
        'Please be sure to provide the company name, BIN, and contact phone number.',
      formCheckBox1: 'I confirm',
      formCheckBox2:
        'my consent to the collection and processing of personal data',
      formPlaceholder1: 'Company',
      formPlaceholder2: 'BIN',
      formPlaceholder3: 'Full Name',
      formPlaceholder4: 'Phone',
      formPlaceholder5: 'Email',
      formPlaceholder6: 'Comment',
      formButtonText: 'Submit Application',
      formSuccessStatus: 'Your application has been submitted successfully.',
      formErrorStatus: 'Failed to submit the application.',
      formErrorMessage:
        'Please try submitting the application again in 4 hours.',
      formSendClose: 'Close',
      trustTitle: 'Why clients trust Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 years',
            content: 'on the insurance market of Kazakhstan',
          },
          {
            id: 2,
            title: 'TOP 2',
            content: 'by volume of insurance payouts',
          },
          {
            id: 3,
            title: 'kzA-',
            content: 'financial stability rating by S&P Global Ratings',
          },
          {
            id: 4,
            title: '600+',
            content: 'employees working across the country',
          },
        ],
        second: [
          {
            id: 5,
            title: '₸59.4 billion',
            content: 'insurance premiums collected in 2024',
          },
          {
            id: 6,
            title: '₸22 billion',
            content: 'insurance payouts made in 2024',
          },
        ],
        third: '(According to the National Bank of Kazakhstan, Jan–Feb 2025)',
      },
    },
  },
  kz: {
    voluntaryCargo: {
      title: 'Жүктерді сақтандыру',
      description:
        'Жүктеріңіздің жөнелтілген сәттен бастап алуға дейін бүкіл маршрутта сақталуын қамтамасыз етіңіз. Шешімдер шағын бизнестен бастап ірі логистикалық операторларға дейінгі барлық көлемдегі компанияларға қажетті.',
      buttonText: 'Өтініш беру',
      infoCards: [
        {
          title: 'Сақтандыру не үшін қажет',
          content:
            'Тасымалдаудың барлық кезеңдерінде жүктерді жоғалту, зақымдану немесе ұрлату тәуекелдерінен қорғау.',
        },
        {
          title: 'Дербес талаптар',
          content:
            'Сақтандыру талаптары жүк санатына және тасымалдау маршрутына байланысты әрбір клиент бойынша дербес белгіленеді.',
        },
        {
          title: 'Сенімділікті арттыру',
          content:
            'Сақтандырылған жүк қажет болған жағдайда, белгілі Халықаралық қайта сақтандыру компанияларында қосымша қорғаныс алуы мүмкін.',
        },
      ],
      coverage: [
        {
          title: 'Нені сақтандырамыз',
          description: 'Жүк тасымалдаудың кез келген түрі:',
          content: [
            'Әуе көлігімен',
            'Теңіз көлігімен',
            'Автомобиль көлігімен',
            'Темір жол көлігімен',
            'Мультимодальды / аралас тасымалдау',
          ],
        },
        {
          title: 'Қандай тәуекелдерден',
          description:
            'Таңдалған өтем пакетіне байланысты төмендегідей тәуекелдер сақтандырылуы мүмкін:',
          content: [
            'барлық тәуекелдер үшін жауапкершілікпен',
            'жеке авария үшін жауапкершілікпен',
            'жүктің толық жойылуы үшін ғана жауапкершілікпен',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Сақтандыру сомасы',
          content:
            'Коммерциялық инвойсқа (шот-фактураға), көлік жүкқұжатына және т. б. сәйкес жүк құнына қарай дербес анықталады.',
        },
        {
          title: 'Қолданыс мерзімі',
          content: 'Тасымалдаудың барлық кезеңіне.',
        },
        {
          title: 'Сақтандыру аумағы',
          content: 'Тасымалдау бағытына сәйкес.',
        },
      ],
      formTitle: 'Өтінім қалдыру',
      formDescription: 'БСН және байланыс телефонын көрсетуді ұмытпаңыз.',
      formCheckBox1: 'Мен',
      formCheckBox2:
        'жеке деректерімді жинауға және өңдеуге келісімімді растаймын',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БСН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.пошта',
      formPlaceholder6: 'Түсініктеме',
      formButtonText: 'Жөнелту',
      formSuccessStatus: 'Сіздің өтінішіңіз сәтті жіберілді.',
      formErrorStatus: 'Өтінішті жіберу сәтсіз аяқталды.',
      formErrorMessage: 'Өтінішті 4 сағаттан кейін жіберіп көріңіз.',
      formSendClose: 'Жабу',
      trustTitle: 'Неліктен клиенттер Alatau City Garant-қа сенім артады',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 жыл',
            content: 'Қазақстанның сақтандыру нарығында қызмет еткеніне',
          },
          {
            id: 2,
            title: '3 орын',
            content:
              '2024 жылы ҚР жалпы сақтандыру компаниялары арасында сақтандыру төлемдерінің көлемі бойынша',
          },
          {
            id: 3,
            title: 'ВВ-Болжам «Тұрақты»',
            content: 'S&P Global Ratings қаржылық тұрақтылық рейтингі',
          },
          {
            id: 4,
            title: '22 филиал',
            content: 'Alatau City Garant бүкіл ел аумағында жұмыс істейді',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content:
              'сақтандыру сыйлықақыларын Alatau City Garant 2024 жылы жинады',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'Alatau City Garant 2024 жылы клиенттерге төледі',
          },
        ],
        third: '(ҚР Ұлттық Банкінің деректері бойынша)',
      },
      businessDescription:
        'Жүктеріңіздің бүкіл маршрут бойында — жөнелтуден бастап қабылдауға дейінгі сақталуын қамтамасыз етіңіз.',
    },
  },
  ru: {
    voluntaryCargo: {
      title: 'Страхование грузов',
      description:
        'Обеспечьте сохранность ваших грузов на всём маршруте: от момента отправки до получения. Решения подходят для компаний любого масштаба — от малого бизнеса до крупных логистических операторов.',
      buttonText: 'Отправить заявку',
      infoCards: [
        {
          title: 'Для чего нужна страховка',
          content:
            'Защита от рисков утраты, повреждения или хищения грузов на всех этапах перевозки.',
        },
        {
          title: 'Персональные условия',
          content:
            'Условия страхования устанавливаются по каждому клиенту индивидуально, в зависимоти от категории груза и маршрута перевозки.',
        },
        {
          title: 'Повышение доверия',
          content:
            'Застрахованный груз может иметь дополнительную защиту в известных международных перестраховочных компаниях, при необходимости.',
        },
      ],
      coverage: [
        {
          title: 'Что страхуем',
          description: 'Любые виды грузоперевозок:',
          content: [
            'Воздушным транспортом',
            'Морским транспортом,',
            'Автомобильным транспортом',
            'Железнодорожным транспортом',
            'Мультимодальные/комбинированные перевозки',
          ],
        },
        {
          title: 'От каких рисков',
          description:
            'В зависимости от выбранного пакета покрытий, застрахованы могут быть риски:',
          content: [
            'С ответственностью за все риски',
            'С ответственностью за частную аварию',
            'С ответственностью только за полную гибель груза',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Страховая сумма',
          content:
            'Определяется индивидуально, исходя из стоимости груза,  в соответствии с коммерческим инвойсом (счет-фактурой), транспортной накладной и т.д.',
        },
        {
          title: 'Срок действия',
          content: 'На весь период перевозки.',
        },
        {
          title: 'Территория страхования',
          content: 'Согласно маршруту перевозки.',
        },
      ],
      formTitle: 'Заявка на страхование',
      formDescription:
        'Пожалуйста, обязательно укажите БИН и контактный телефон.',
      formCheckBox1: 'Я подтверждаю ',
      formCheckBox2: 'согласие на сбор и обработку персональных данных',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БИН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.почта',
      formPlaceholder6: 'Комментарий',
      formButtonText: 'Отправить заявку',
      formSuccessStatus: 'Спасибо! Ваша заявка отправлена',
      formErrorStatus: 'Не удалось отправить заявку',
      formErrorMessage: 'Попробуйте отправить заявку через 4 часа.',
      formSendClose: 'Закрыть',
      trustTitle: 'Почему клиенты доверяют Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 лет',
            content: 'на страховом рынке Казахстана',
          },
          {
            id: 2,
            title: '3 место',
            content:
              'по объему страховых выплат среди компаний общего страхования РК в 2024 году',
          },
          {
            id: 3,
            title: 'ВВ-прогноз «Стабильный»',
            content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
          },
          {
            id: 4,
            title: '22 филиала',
            content: 'Alatau City Garant работают по всей стране ',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content: 'страховых премий собрал Alatau City Garant в 2024 году',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'выплатил Alatau City Garant клиентам в 2024 году ',
          },
        ],
        third: '(по данным Нацбанка РК)',
      },
      businessDescription:
        'Обеспечьте сохранность ваших грузов на всём маршруте: от момента отправки до получения.',
    },
  },

  mainCard: {
    image: MainImage,
  },
  infoCards: [
    {
      id: 1,
      image: VectorFirst,
    },
    {
      id: 2,
      image: VectirSecond,
    },
    {
      id: 3,
      image: VectorThird,
    },
  ],
  coverage: [
    {
      title: 'Что страхуем?',
      description: 'Любые виды грузоперевозок:',
      content: [
        'Воздушным транспортом',
        'Морским транспортом,',
        'Автомобильным транспортом',
        'Железнодорожным транспортом',
        'Мультимодальные/комбинированные перевозки',
      ],
      image: Checkbox,
    },
    {
      title: 'От каких рисков?',
      description:
        'В зависимости от выбранного пакета покрытий, застрахованы могут быть риски:',
      content: [
        'С ответственностью за все риски',
        'С ответственностью за частную аварию',
        'С ответственностью только за полную гибель груза',
      ],
      image: Thunder,
    },
    {
      title: 'Иллюстрация',
      content: [],
      image: Contract,
    },
  ],
  featureCards: [
    {
      title: 'Страховая сумма',
      content:
        'Определяется индивидуально, исходя из стоимости груза и маршрута перевозки.',
    },
    {
      title: 'Срок действия',
      content:
        'На весь период перевозки — от пункта отправления до точки доставки.',
    },
    {
      title: 'Территория действия',
      content:
        'Республика Казахстан и международные маршруты, включая мультимодальные перевозки.',
    },
  ],
  trustCards: {
    first: [
      {
        id: 1,
        title: '17 лет',
        content: 'на страховом рынке Казахстана',
        image: Shield,
      },
      {
        id: 2,
        title: 'ТОП 2',
        content: 'по объёму страховых выплат ',
        image: Star,
      },
      {
        id: 3,
        title: 'kzA-',
        content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
        image: Pyramid,
      },
      {
        id: 4,
        title: '600+',
        content: 'сотрудников работают по всей стране',
        image: People,
      },
    ],
    second: [
      {
        title: '59,4 млрд ₸',
        content: 'страховых премий собрано за 2024 год ',
      },
      {
        title: '22 млрд ₸',
        content: 'выплачено по страховым случаям за 2024 год',
      },
    ],
    image: Box,
  },
};

export default voluntaryCargoResources;
